export type ApiFetchStatus = "idle" | "loading" | "success" | "error"


export class ApiError extends Error {
  constructor(message: string) {
    super(message || "unknown_error")
    this.name = "ApiError"
  }
}
